import { OrderLine } from '@models/order';

export function makeItemKey(item: OrderLine): string {
    const options = item
        ? [...item.defaultOptions, ...item.personalOptions]
            .map((it) => it.options)
            .flat() : undefined;
    // 옵션 순서가 클라이언트와 서버 간에 다를 수 있으므로 정렬하여 동일 키 보장
    const optionKey = options
        ?.map((it) => `${it.posId}x${it.quantity}`)
        .sort()
        .join(':');

    return [item?.posId, optionKey]
        .filter((it) => !!it)
        .join(':');
}
